import apiFetch from '../apiFetch'

export default function (id, token) {
  return apiFetch({endPoint: `ComboObservacionesEyaculadoEliminado/getComboObservacionesEyaculadoEliminado?id=${id}`, method: 'GET', body: null, token: token})
}
